
import { IADropdown } from "../factory";

const openMobileSubmenu = () => {
    document.querySelectorAll('header .menu-item-has-children > a').forEach(menu => {
        const openMenuBtn = document.createElement('button')
        openMenuBtn.textContent = '+'
        openMenuBtn.setAttribute('class', 'open-menu-btn')
        menu.appendChild(openMenuBtn)
        openMenuBtn.addEventListener('click', function(e){
            e.preventDefault()
            Array.from(openMenuBtn.classList).indexOf('active') !== -1 ? openMenuBtn.textContent = '+' : openMenuBtn.textContent = '-'
        })
        new IADropdown(openMenuBtn, openMenuBtn.parentElement.nextElementSibling)
    });
}

export default openMobileSubmenu